export function itemDataInRootState(rootState) {
  const itemId = rootState.item.selectedItemId;
  const { area, property } = areaDataInRootState(rootState)

  return {
    item: area.items.find(i => i.id == itemId),
    property,
    area
  };
}

export function areaDataInRootState(rootState) {
  const propertyId = rootState.property.selectedPropertyId;
  const property = rootState.property.properties.find(p => p.id == propertyId);
  const areaId = rootState.area.selectedAreaId;

  return {
    area: property.areas.find(a => a.id == areaId),
    property
  };
}
